// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2wpA5","footer":"ModalUpdate_footer__Tl1g5"};